import { IUnit } from "../interfaces/unit";

export class PowerUnits {
  static hp: IUnit = { id: 0, display: 'HP' };
  static kw: IUnit = { id: 1, display: 'Kw' };
  static cv: IUnit = { id: 2, display: 'CV' };

  static getById(id: number) {
    let values = Object.values(PowerUnits);
    return values[id];
  }

  static powerToHp(power: number, powerUnits: string): number {
    switch (powerUnits) {
      case PowerUnits.kw.display:
        return power = power * 1.34102;
        break;
      case PowerUnits.cv.display:
        return power * 0.98592;
        break
      default:
        return power;
        break;
    }
  }

  static hpToPower(power: number, powerUnits: string): number {
    switch (powerUnits) {
      case PowerUnits.kw.display:
        return power / 1.34102;
        break;
      case PowerUnits.cv.display:
        return power / 0.98592;
        break;
      default:
        return power;
        break;
    }

  }
}

